import merge from 'deepmerge';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from './GlobalStyles';
import { theme as defaultTheme } from './theme';
export const JukeboxProvider = _ref => {
  let {
    theme = {},
    children
  } = _ref;
  const customTheme = React.useMemo(() => merge(defaultTheme, theme, {
    arrayMerge: (_, sourceArray) => sourceArray
  }), [theme]);
  return React.createElement(ThemeProvider, {
    theme: customTheme
  }, React.createElement(GlobalStyles, null), children);
};